import React, { Component } from 'react';
import { Alert } from 'modules/theme';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
// import ' node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '../../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import APIManager from 'modules/common/apiManager';
import styled from 'styled-components';
import {
  ButtonCommonTheme,
  FormControl, FormGroup,
  ControlLabel
} from 'modules/theme';
import {
  ModalFooter,
  FormWrapper,
  FormColumn
} from 'modules/theme';
import draftToHtmlPuri from "draftjs-to-html";
import { convertToRaw, EditorState, ContentState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import { ModalForm, ModalFormContainer } from '../../../../theme/theme1/common/styles/main';

const ResetCss = styled.div`
img{
  height:auto;
  width:auto;
  border-radius:0px;
}
// .public-DraftStyleDefault-ltr {
//   direction: ltr;
//   /* border: 2px solid black; */
//   text-align: left;
//   background: #FFFFFF;
//   box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
//   border-radius: 10px;
//   height: 100px;
//   width: 90%;
//   margin: 15px auto;
//   padding: 5px;
// }
.DraftEditor-root{
  z-index:0;
  direction: ltr;
  text-align: left;
  background: #FFFFFF;
  box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
  border-radius: 10px;
  height: 100%;
  min-height: 120px;
  max-height: 130px;
  width: 95%;
  margin: 15px auto;
  padding: 5px;
  word-break: break-all;
  overflow: auto;
}
`;
const EditorContainer = styled.div`
  .rdw-emoji-modal {
    left: auto !important;
    right: 0;
    width: 240px;
  }
`;
export class EmailtempleteAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData && this.props.editData._id) {
      this.state = {
        name: this.props.editData.name,
        templete: this.props.editData.templete,
        editorState: this.htmlConverter(this.props.editData.templete)
      };
    } else {
      this.state = {
        name: '',
        templete: '',
        contentState: {},
        editorState: EditorState.createEmpty(),

      };
    }
  }
  htmlConverter(plainHtml) {
    const html = plainHtml;
    const contentBlock = htmlToDraft(html);
    
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      
      // this.state = {
      //   editorState
      // };
      // this.setState({editorState:editorState})
      return editorState
    }
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
      name: '',
      type: '',
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  saveData(e) {
    let _this = this;
    e.preventDefault();
    this.props.clearSearchField();
	if (!this.state.editorState.getCurrentContent().getPlainText('\u0001').trim()) return Alert.error(`Please enter a template`);
    const htmlPuri = draftToHtmlPuri(
      convertToRaw(this.state.editorState.getCurrentContent())
    );
    
    let tData = {
      name: this.state.name.trim(),
      templete: htmlPuri,
      type: "text",
      valueObj: []
    };

    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `setting/email-templete/${this.props.editData._id}`,
        tData,
        data => {
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(data.message);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        'setting/email-templete',
        tData,
        data => {
          if (data && data.message) {
            Alert.success(data.message);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }
  onContentStateChange = (templete) => {
    this.setState({
      templete,
    });
    
  };
  onEditorStateChange = editorState => {
    
    this.setState({ editorState });
  };
  render() {
    const { modalType } = this.props;
    
    return (
      <ModalForm onSubmit={(e) => this.saveData(e)} autoComplete={false}>
        <ModalFormContainer>
          <FormWrapper>
            <FormColumn>
              {this.renderFormGroup('name', {
                placeholder: 'Name',
                defaultValue: '',
                autoFocus: true,
                required: true,
                id: 'name',
                maxLength: 25,
                value: this.state.name,
                onChange: (e) => {
                  if (e.target.value === ' ') {
                    return false;
                  }
                  let agentName =
                    e.target.value && e.target.value.trim() == ''
                      ? ''
                      : e.target.value;
                  this.setState({ name: agentName });
                },
              })}
              <ResetCss>
                <FormGroup>
                  <ControlLabel required={true}>{'template'}</ControlLabel>
                  <EditorContainer>
                    <Editor
						placeholder={<span style={{position: "relative", top: "14px"}}>Add Template Here...</span>}
						editorState={this.state.editorState}
						onEditorStateChange={this.onEditorStateChange}
                    />
                  </EditorContainer>
                </FormGroup>
              </ResetCss>
            </FormColumn>
          </FormWrapper>
        </ModalFormContainer>

        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            OnClick={() => this.props.closeModal()}
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme type='blueModalBtn' btnType='submit'>
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </ModalForm>
    );
  }
}

EmailtempleteAddEdit.propTypes = {
  group: PropTypes.array
};

EmailtempleteAddEdit.contextTypes = {
  __: PropTypes.func
};

export default EmailtempleteAddEdit


// WEBPACK FOOTER //
// src/modules/screens/settings/EmailTemplete/components/EmailtempleteAddEdit.js